import { render, staticRenderFns } from "./ChartIndex.vue?vue&type=template&id=20df0cf8&scoped=true&"
import script from "./ChartIndex.vue?vue&type=script&lang=js&"
export * from "./ChartIndex.vue?vue&type=script&lang=js&"
import style0 from "./ChartIndex.vue?vue&type=style&index=0&id=20df0cf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20df0cf8",
  null
  
)

export default component.exports